import { motion } from 'motion/react';
import { Sparkles, VolumeX } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface VoiceResponseCardProps {
  text: string;
  isSpeaking: boolean;
  onStopSpeaking: () => void;
  className?: string;
}

function summarize(text: string): string {
  const sentences = text.split(/(?<=[.!?])\s+/);
  const first3 = sentences.slice(0, 3).join(' ');
  return first3.length > 300 ? first3.slice(0, 300) + '…' : first3;
}

export function VoiceResponseCard({
  text,
  isSpeaking,
  onStopSpeaking,
  className,
}: VoiceResponseCardProps) {
  if (!text) return null;

  const summary = summarize(text);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
      className={cn(
        'mx-6 rounded-lg border-[length:var(--border-brutal)] border-charcoal-950 dark:border-charcoal-600 bg-white dark:bg-charcoal-800 p-4 shadow-[3px_3px_0_#0D0D1A]',
        className,
      )}
    >
      <div className="flex items-start gap-3">
        <div className="flex shrink-0 items-center justify-center size-8 rounded-full bg-lime-100 dark:bg-lime-900/40">
          <Sparkles className="size-4 text-lime-600 dark:text-lime-400" />
        </div>
        <p className="text-sm leading-relaxed text-charcoal-800 dark:text-neutral-200">{summary}</p>
      </div>

      {isSpeaking && (
        <div className="mt-3 flex items-center justify-end">
          <Button variant="ghost" size="xs" onClick={onStopSpeaking}>
            <VolumeX className="size-3.5" />
            Arreter
          </Button>
        </div>
      )}
    </motion.div>
  );
}
